<template>
    <div id="pick-material-task">
        <div style="width:100%;heigh:100%;">
            <el-card class="table_searchbar">
                <el-row :gutter="20">
                    <el-col :span='5'>
                        <div @keydown.enter="btnSearch()" class="span_flex">
                            <span class="title">到货单号：</span>
                            <el-select size="small" @visible-change="closeSelect($event)"  clearable    filterable remote :remote-method="remoteMethod" 
                                :loading="loading" style="max-width:180px;" v-model="searchForm.arrivalId" placeholder="到货单号" >
                                <el-option v-for="item in arrivalList" :key="item.id" :label="item.arrivalCode" :value="item.id"></el-option>
                            </el-select>
                        </div>
                    </el-col>
                    <el-col :span="5">
                        <div class="" @keydown.enter="btnSearch()">
                            <span class="title">采购单号：</span>
                            <el-select size="small" style="max-width:180px;" @visible-change="closeSelect1($event)"  clearable    filterable remote :remote-method="remoteMethod1" 
                                :loading="loading" v-model="searchForm.purchaseId" placeholder="采购单号" >
                                <el-option v-for="item in purchaseSelectList" :key="item.purchaseId" :label="item.purchaseCode" :value="item.purchaseId"></el-option>
                            </el-select>
                        </div>
                    </el-col>
                    <el-col :span="10">
                        <div class="" @keydown.enter="btnSearch()">
                            <span class="title">到货日期：</span>
                            <el-date-picker style="width:533px" v-model="searchForm.arrivalTime" type="daterange" range-separator="至" start-placeholder="开始日期"  end-placeholder="结束日期" value-format="yyyy-MM-dd"   ></el-date-picker>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <div style="text-align:right">
                            <a style="margin-right: 12px;cursor: pointer;font-size: 12px;" @click="toggleShowMore">
                                {{ showMore ? '收起' : '展开' }}
                                <i :class="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
                            </a>
                            <el-button size="mini" icon="el-icon-search" type="primary" @click="btnSearch()">查询</el-button>
                            <el-button size="mini" icon="el-icon-refresh" @click='clearSearch'>重置</el-button>
                        </div>
                    </el-col>
                </el-row>
                <el-collapse-transition>
                    <div v-show="showMore">
                        <el-row :gutter="20">
                            <el-col :span="5">
                                <div class="" @keydown.enter="btnSearch()">
                                    <span class="title" style="width:86px;margin-left:-16px">供应商名称：</span>
                                    <el-input style="max-width:180px" size="small" v-model="searchForm.supplier"  placeholder="供应商名称"></el-input>
                                </div>
                            </el-col>
                            <el-col :span="5">
                                <div class="" @keydown.enter="btnSearch()" >
                                    <span class="title" >到货仓库：</span>
                                    <el-select size="small" style="max-width:180px;" filterable v-model="searchForm.factoryModelId" placeholder="到货仓库" clearable>
                                        <el-option v-for="item in factoryModelList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                    </el-select>
                                </div>
                            </el-col>
                            <el-col :span="10">
                                <div class="" @keydown.enter="btnSearch()">
                                    <span class="title">采购日期：</span>
                                    <el-date-picker style="width:533px" v-model="searchForm.purchaseTime" type="daterange" range-separator="至" start-placeholder="开始日期"  end-placeholder="结束日期" value-format="yyyy-MM-dd"   ></el-date-picker>
                                </div>
                            </el-col>
                            
                        </el-row>
                    </div>
                </el-collapse-transition>
            </el-card>
            <el-card class="table-card">
                <div class="table_common_operbar" v-if="permission.btn_arrivalNotice_addArrivalNotice">
                    <el-row>
                        <el-button icon="el-icon-plus" type="primary" size="small" @click="addWindowShow()">新增</el-button>
                    </el-row>
                </div>

                <el-table :data="tableData" style="width: 100%" class="deviceTable" >
                    <el-table-column type="index" label="序号" width="60"></el-table-column>
                    <el-table-column prop="arrivalCode" label="到货单号" min-width="120"></el-table-column>
                    <el-table-column prop="purchaseCode" label="采购单号" min-width="110"></el-table-column>
                    <el-table-column prop="supplier" label='供货商名称' min-width="120"></el-table-column>
                    <el-table-column prop="purchaseTime" label='采购日期' :formatter='(row, column, cellValue, index)=>$commonUtil.changeToDate(row, column, cellValue, index,true)'  min-width="110"></el-table-column>
                    <el-table-column prop="arrivalTime" label='到货日期' :formatter='(row, column, cellValue, index)=>$commonUtil.changeToDate(row, column, cellValue, index,true)' min-width="110"></el-table-column>
                    <el-table-column prop="factoryModelName" label="到货仓库" min-width="140" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="operationUserName" label='操作人' min-width="140" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="gmtModified" label="更新时间" :formatter='$commonUtil.changeToDate' min-width="120"></el-table-column>
                    <el-table-column label="操作" fixed="right" width="160">
                        <template slot-scope="scope">
                            <el-button type="text"  @click="showViewDialog(scope.row)" size="small">查看</el-button>
                            <el-button type="text" v-if="permission.btn_arrivalNotice_updateArrivalNotice" @click="showEditDialog(scope.row)" size="small">编辑</el-button>
                            <el-button class="btn-del" type="text" v-if="permission.btn_arrivalNotice_removeArrivalNotice" @click="deleteArrivalCode(scope.row)" size="small">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <div class="page" v-if="tableData.length > 0">
                    <div class="total_page"><span> 共{{tableTotalPage}}条 10条/页</span></div>
                    <div style="margin-top:10px;text-align:right; margin-bottom:20px;">
                        <el-pagination background layout="prev, pager, next" :total="tableTotalPage" @current-change="pageChange" :current-page="tableCurrentPage">
                        </el-pagination>
                    </div>
                </div>
            </el-card>
            

            <!-- 新增到货通知开始 -->
            <el-dialog title="新增到货通知" @close="cancelAddDialog" :visible.sync="addDialogVisible" :width="span==5?'50%':'63%'"  center :close-on-click-modal="false">
                <el-form :model="addForm" :rules="rules" ref="addForm" style="width:100%;" class="add_form">
                    <el-row :gutter="20" >
                        <el-col :span="8">
                            <span class="title">采购单号：</span>
                            <el-form-item prop="purchaseId" class="value" :rules="rules.purchaseId" :style="W?{maxWidth:'180px'}:{maxWidth:'140px'}">
                                <el-select size="small" ref="focusinput" @change="purchaseSelect" @visible-change="closeSelect2($event)" clearable    filterable remote :remote-method="remoteMethod2" 
                                :loading="loading"  v-model="addForm.purchaseId" placeholder="采购单号"  style="display:block;max-width:180px">
                                    <el-option v-for="item in purchaseList" :key="item.purchaseId" :label="item.purchaseCode" :value="item.purchaseId"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <span class="title">到货日期：</span>
                            <el-form-item class="value" prop="arrivalTime" :style="W?{maxWidth:'180px'}:{maxWidth:'140px'}">
                                <el-date-picker  popper-class='timer' v-model="addForm.arrivalTime" type="date" format="yyyy-MM-dd" placeholder="到货日期" style="width:100%"></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <span class="title">到货仓库：</span>
                            <el-form-item class="value" prop="factoryModelId" :style="W?{maxWidth:'180px'}:{maxWidth:'140px'}">
                               <el-select size="small" ref="focusinput" @change="factoryModelSelect"  v-model="addForm.factoryModelId" placeholder="到货仓库" filterable style="display:block;max-width:180px">
                                    <el-option v-for="item in factoryModelList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                   
                    <el-table :data="addForm.arrivalNoticeDetails" stripe style="width: 100%;margin-bottom:10px;" class="marterial-table">
                        <el-table-column label="序号"  min-width="40" >
                            <template slot-scope="scope">
                                <el-form-item>
                                    <span>{{scope.$index+1}}</span>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column label="物料编码" min-width="100">
                            <template slot-scope="scope">
                                <el-form-item   >
                                    {{scope.row.materialCode}}
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column label="物料名称" min-width="100">
                            <template slot-scope="scope">
                                <el-form-item >
                                   {{scope.row.materialName}}
                                </el-form-item>
                            </template>
                        </el-table-column>

                        <el-table-column label="规格" min-width="100">
                            <template slot-scope="scope">
                                <el-form-item >
                                   {{scope.row.specification}}
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column label="采购数量" min-width="80">
                            <template slot-scope="scope">
                                <el-form-item >
                                    <span>{{scope.row.purchaseAmount}}</span>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column label="到货数量" min-width="140">
                            <template slot-scope="scope">
                                <el-form-item :prop="`arrivalNoticeDetails[${scope.$index}]`"  :rules="rules.arrivalAmount">
                                    <el-input v-model="scope.row.arrivalAmount"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="submitAddDialog">确 定</el-button>
                    <el-button @click="cancelAddDialog">取 消</el-button>
                </span>
            </el-dialog>
            <!-- 新增到货通知结束 -->

            <!-- 编辑到货通知开始 -->
            <el-dialog title="编辑到货通知" @close="cancelEditDialog" :visible.sync="editDialogVisible" :width="span==5?'54%':'64%'"  center :close-on-click-modal="false">
                <el-form :model="addForm" :rules="rules" ref="editForm" style="width:100%;" class="add_form">
                    <el-row :gutter="20" >
                        <el-col :span="8">
                            <span class="title">到货单号：</span>
                            <el-form-item  class="value"  >
                                {{addForm.arrivalCode}}
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <span class="title">采购单号：</span>
                            <el-form-item  class="value"  >
                                {{addForm.purchaseCode}}
                            </el-form-item>
                        </el-col>
                        
                        <el-col :span="8">
                            <span class="title">到货日期：</span>
                            <el-form-item class="value" prop="arrivalTime" >
                                <el-date-picker  popper-class='timer' v-model="addForm.arrivalTime" type="date" format="yyyy-MM-dd" placeholder="到货日期" style="width:100%"></el-date-picker>
                            </el-form-item>
                        </el-col>
                        
                    </el-row>
                    <el-row :gutter="20" >
                        <el-col :span="8">
                            <span class="title">到货仓库：</span>
                            <el-form-item class="value" prop="factoryModelId" >
                                <el-select size="small" ref="focusinput" @change="factoryModelSelect"  v-model="addForm.factoryModelId" placeholder="到货仓库" filterable style="display:block;max-width:180px">
                                   <el-option v-for="item in factoryModelList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    
                   
                    <el-table :data="addForm.arrivalNoticeDetails" stripe style="width: 100%;margin-bottom:10px;" class="marterial-table">
                       
                        <el-table-column  min-width="60" >
                            <template slot-scope="scope">
                                <el-form-item>
                                    <span>{{scope.$index+1}}</span>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column label="物料编码" min-width="80">
                            <template slot-scope="scope">
                                <el-form-item   >
                                    {{scope.row.materialCode}}
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column label="物料名称" min-width="80">
                            <template slot-scope="scope">
                                <el-form-item >
                                   {{scope.row.materialName}}
                                </el-form-item>
                            </template>
                        </el-table-column>

                        <el-table-column label="规格" min-width="110">
                            <template slot-scope="scope">
                                <el-form-item >
                                   {{scope.row.specification}}
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column label="采购数量" min-width="80">
                            <template slot-scope="scope">
                                <el-form-item >
                                    <span>{{scope.row.purchaseAmount}}</span>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column label="到货数量" min-width="140">
                            <template slot-scope="scope">
                                <el-form-item :prop="`arrivalNoticeDetails[${scope.$index}]`"  :rules="rules.arrivalAmount">
                                    <el-input v-model="scope.row.arrivalAmount"></el-input>
                                </el-form-item>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="submitEditDialog">保 存</el-button>
                    <el-button @click="cancelEditDialog">取 消</el-button>
                </span>
            </el-dialog>
            <!-- 编辑到货通知结束 -->

            <!-- 查看到货通知开始 -->
            <el-dialog title="查看到货通知" @close="cancelViewDialog" :visible.sync="viewDialogVisible" :width="span==5?'50%':'64%'"   center :close-on-click-modal="false">
                
                <el-row :gutter="20" style="margin-bottom:30px">
                    <el-col :span="8">
                        <span class="title">到货单号：</span>
                        <span>{{addForm.arrivalCode}}</span>
                    </el-col>
                    <el-col :span="8">
                        <span class="title">采购单号：</span>
                        <span>{{addForm.purchaseCode}}</span>
                    </el-col>
                    <el-col :span="8">
                        <span class="title">到货日期：</span>
                        <span>{{addForm.arrivalTime|parseTime}}</span>
                    </el-col>
                </el-row>
                <el-row :gutter="20" style="margin-bottom:30px">
                    <el-col :span="8">
                        <span class="title">到货仓库：</span>
                        <span>{{addForm.factoryModelName}}</span>
                    </el-col>
                </el-row>
            
                <el-table :data="arrivalNoticeDetails" stripe style="width: 100%;margin-bottom:10px;" class="part-table" @selection-change="handleSelectionChange">
                    <el-table-column  min-width="60" type="selection"></el-table-column>
                    <!-- <el-table-column label="序号" type="index" min-width="60"></el-table-column> -->
                    <el-table-column label="物料编码" min-width="80" prop="materialCode"></el-table-column>
                    <el-table-column label="物料名称" min-width="110" prop="materialName" ></el-table-column>
                    <el-table-column label="规格" min-width="80" prop="specification"></el-table-column>
                    <el-table-column label="采购数量" min-width="140" prop="purchaseAmount"></el-table-column>
                    <el-table-column label="到货数量" min-width="140" prop="arrivalAmount"></el-table-column>
                </el-table>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="printOrder()" size="small">打印条码</el-button>
                    <el-button @click="cancelViewDialog" >取 消</el-button>
                </span>
            </el-dialog>
            <!-- 新增到货通知结束 -->

        </div>
    </div>
</template>

<script>

export default {
    name: 'NoticeOfArrival',
    data() {
        return {
            showMore:false,
            selectList:[],
            purchaseSelectList:[],
            purchaseList:[],
            arrivalList:[],
            factoryModelList:[],
            addDialogVisible:false,
            editDialogVisible:false,
            viewDialogVisible:false,
            fristLoad: false,
            addForm:{
                purchaseId:null,
                purchaseCode:'',
                arrivalTime:null,
                factoryModelName:'',
                factoryModelId:'',
                arrivalNoticeDetails:[],
            },
            arrivalNoticeDetails:[],
            selectRow: {},
            showPage: 1,
            W: false,
            btnPressType: 0,//按钮类型： 0-默认 1-查询 2-重置 3-分页
            searchFormTemp: '',//临时搜索数据
            searchForm: {
                purchaseId:null,
                arrivalId:null,
                arrivalTime:[],
                purchaseTime:[],
                supplier:'',
                factoryModelId:null,
            },
            tableData: [],
            tableCurrentPage: 1,
            tableTotalPage: 2,
            rules:{
                purchaseId:[
                    { required: true, message: '请选择采购单号', trigger: 'blur' }
                ],
                factoryModelId:[
                    { required: true, message: '请选择仓库', trigger: 'blur' }
                ],
                arrivalTime:[
                    { required: true, message: '请选择到货时间', trigger: 'blur' }
                ],
                arrivalAmount:[
                    {validator(rule, item, callback) {
                        let value = item.arrivalAmount
                        let purchaseAmount = item.purchaseAmount
                        if(value===''||value==undefined||value==null){
                            callback(new Error('到货数量不能为空'))
                        }
                        value = Number(value)
                        if(Number.isNaN(value)){
                             callback(new Error('到货数量必须为数字'))
                        }else{
                            if(value<=0){
                                callback(new Error('到货数量必须大于零'))
                            }else{
                                
                                if(value>purchaseAmount){
                                    callback(new Error('到货数量不能大于采购数量'))
                                }else{
                                    callback()
                                }
                            }
                        }
                        
					},trigger: 'blur'}
                ],
            },
            loading:false,
            data: {
                token: localStorage.getItem("token"),
            },
            permission: JSON.parse(localStorage.getItem("permission"))
        }
    },
    mounted: async function () {
        this.initTable();
        this.loadArrivalList()
        this.purchaseSelectList = await this.loadPurchaseList()
        this.loadFactoryModelList()
        let w = document.documentElement.clientWidth || document.body.clientWidth;
        w >= 1900 ? this.W = true : this.W = false
        window.onresize = () => {
            let w = document.documentElement.clientWidth || document.body.clientWidth;
            w >= 1900 ? this.W = true : this.W = false
        }
    },
    computed: {
        span() {
            return this.W ? 5 : 6
        }
    },
    deactivated: function () {
        console.log("deactivated");
    },
    methods: {
        toggleShowMore(){
            this.showMore = ! this.showMore
        },
        reload() {
            this.initTable();
        },

        async loadArrivalList(arrivalCode){
            let res = await this.$RequestUtil.getAsync({url: '/api/select/listArrivalCode',params: {arrivalCode},})
            if(res.code!=0){
                this.$message.error(res.msg||res.message)
                return
            }
            this.arrivalList = res.data
        },

        async loadPurchaseList(purchaseCode,executingStatus){
            let res = await this.$RequestUtil.getAsync({url: '/api/select/listPurchaseCode',params: {purchaseCode,executingStatus},})
            if(res.code!=0){
                this.$message.error(res.msg||res.message)
                return
            }
            return res.data
        },

        async remoteMethod(query){
            this.loading = true
            await this.loadArrivalList(query)
            this.loading = false
        },

        async remoteMethod1(query){
            this.loading = true
            this.purchaseSelectList = await this.loadPurchaseList(query)
            this.loading = false
        },

        async remoteMethod2(query){
            this.loading = true
            this.purchaseList = await this.loadPurchaseList(query,1)
            this.loading = false
        },

        async purchaseSelect(ev){
            if(ev){
                this.addForm.purchaseCode =  (this.purchaseList.find(item=>item.purchaseId==ev)||{}).purchaseCode
                this.addForm.arrivalNoticeDetails = await this.loadPurchaseDetailByPurchaseId(ev)
            }else{
                this.addForm.purchaseCode =  ''
                this.addForm.arrivalNoticeDetails = []
            }
        },

        factoryModelSelect(ev){
            this.addForm.factoryModelName =  (this.factoryModelList.find(item=>item.id==ev)||{}).name
        },

        closeSelect(ev){
            if(!ev){
                this.loadArrivalList()
            }
        },

        async closeSelect1(ev){
            if(!ev){
                this.purchaseSelectList = await this.loadPurchaseList()
            }
        },

        async closeSelect2(ev){
            if(!ev){
                this.purchaseList = await this.loadPurchaseList(null,1)
            }
        },

        loadFactoryModelList(arrivalCode){
            this.$RequestUtil.get({
                url: '/api/select/listArrivalFactoryModel',
                params: {},
                success:res=>{
                    if(res.code!=0){
                        this.$message.error(res.msg||res.message)
                    }else{
                        this.factoryModelList = res.data
                    }
                }
            })
        },
        
        async loadPurchaseDetailByPurchaseId(purchaseId){
            let res = await this.$RequestUtil.postAsync({url: '/api/arrivalNotice/findPurchaseDetail',params: {purchaseId},})
            if(res.code!=0){
                this.$message.error(res.msg||res.message)
                return
            }
            return res.data
        },

        async addWindowShow(){
            this.addForm.arrivalTime = new Date()
            this.purchaseList = await this.loadPurchaseList(null,1)
            this.addForm.arrivalNoticeDetails = []
            this.addDialogVisible = true
        },

        showViewDialog(rowData){
            this.addForm = commonUtils.cloneObj(rowData)
            this.arrivalNoticeDetails =   this.addForm.arrivalNoticeDetails
            this.viewDialogVisible = true
        },

        showEditDialog(rowData){
            this.addForm = commonUtils.cloneObj(rowData)
            this.editDialogVisible = true
        },

        deleteArrivalCode(rowData) {
            this.$confirm('此操作将删除该到货单, 删除后不可撤销，是否继续?', '提示', {
                cancelButtonClass: "btn-custom-cancel",
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$RequestUtil.post({
                    url: '/api/arrivalNotice/removeArrivalNotice',
                    type: 'sync',
                    params: {
                        arrivalNoticeId: rowData.arrivalNoticeId
                    },
                    success: (res) => {
                        if (res.code != -1) {
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.search(1);
                        } else {
                            this.$message.error(res.message || res.msg)
                        }
                    }
                })
            })
        },

        
        cancelEditDialog() {
            this.editDialogVisible = false
            this.$refs['editForm'].resetFields()
            this.addForm = {
                purchaseId:null,
                purchaseCode:'',
                arrivalTime:null,
                factoryModelName:'',
                factoryModelId:'',
                arrivalNoticeDetails:[],
            }
           
        },

        cancelViewDialog() {
            this.viewDialogVisible = false
            this.addForm = {
                purchaseId:null,
                purchaseCode:'',
                arrivalTime:null,
                factoryModelName:'',
                factoryModelId:'',
                arrivalNoticeDetails:[],
            }
            
            
        },

        cancelAddDialog() {
            this.addDialogVisible = false
            this.$refs['addForm'].resetFields()
            this.addForm = {
                purchaseId:null,
                purchaseCode:'',
                arrivalTime:null,
                factoryModelName:'',
                factoryModelId:'',
                arrivalNoticeDetails:[],
            }
        },

        submitAddDialog() {
            this.$refs['addForm'].validate((valid) => {
                if (valid) {
                    this.$RequestUtil.post({
                        url: '/api/arrivalNotice/addArrivalNotice',
                        type: 'sync',
                        params: this.addForm,
                        success: (res) => {
                            if (res.code == 0) {
                                this.$message.success('添加成功')
                                this.initTable();
                                this.cancelAddDialog()
                            } else {
                                this.$message.error(res.message);
                            }
                        },
                    })

                }
            })
        },

        submitEditDialog() {
            this.$refs['editForm'].validate((valid) => {
                if (valid) {
                    this.$RequestUtil.post({
                        url: '/api/arrivalNotice/updateArrivalNotice',
                        type: 'sync',
                        params: this.addForm,
                        success: (res) => {
                            if (res.code == 0) {
                                this.$message.success('编辑成功')
                                this.initTable();
                                this.cancelEditDialog()
                            } else {
                                this.$message.error(res.message);
                            }
                        },
                    })
                }
            })
        },
        
        btnSearch: function () {
            this.tableCurrentPage = 1;
            this.btnPressType = 1
            this.search();
        },

        clearSearch() {
            let form = this.searchForm;
            this.btnPressType = 2;
            form.purchaseId = null
            form.arrivalId = null
            form.arrivalTime = []
            form.purchaseTime = []
            form.supplier = ''
            form.factoryModelId = null
        },

        search: function () {
            let temp;
            switch (this.btnPressType) {
                case 1:
                    temp = commonUtils.cloneObj(this.searchForm);
                    this.searchFormTemp = commonUtils.cloneObj(temp);
                    break;
                case 0:
                    temp = {
                        purchaseId:null,
                        arrivalId:null,
                        arrivalTime:[],
                        purchaseTime:[],
                        supplier:'',
                        factoryModelId:null,
                    };
                    break;
                case 2:
                    temp = this.searchFormTemp;
                    break;
                case 3:
                    temp = this.searchFormTemp;
                    break;
            }
            let purchaseStartTime = null,purchaseEndTime = null,arrivalStartTime = null,arrivalEndTime = null
            if(temp.arrivalTime&&temp.arrivalTime.length==2){
                arrivalStartTime = temp.arrivalTime[0]
                arrivalEndTime = temp.arrivalTime[1]
            }
            if(temp.purchaseTime&&temp.purchaseTime.length==2){
                purchaseStartTime= temp.purchaseTime[0]
                purchaseEndTime = temp.purchaseTime[1]
            }
            this.$RequestUtil.get({
                url: '/api/arrivalNotice/listArrivalNotice',
                type: 'sync',
                params: {
                    pageNum: this.tableCurrentPage,
                    pageSize: 10,
                    arrivalStartTime,
                    arrivalEndTime,
                    purchaseStartTime,
                    purchaseEndTime,
                    purchaseId:temp.purchaseId,
                    arrivalId:temp.arrivalId,
                    supplier:temp.supplier,
                    factoryModelId:temp.factoryModelId,
                },
                success: (res) => {
                    if (res.msg == this.$Global.RESPONSE.SUCCESS) {
                        this.tableData = res.data;
                        this.tableTotalPage = res.totalPages;
                        if (res.totalPages == 0 && this.fristLoad) {
                            this.$message.warning('查询不到符合条件的数据');
                        }
                        this.fristLoad = true
                    } else {
                        this.$message.error(res.message || res.msg)
                    }
                }
            });
        },

        pageChange: function (targetPage) {
            this.tableCurrentPage = targetPage;
            this.btnPressType = 3;
            this.search();
        },

        initTable: function () {
            this.search();
        },
        
        handleSelectionChange(ev){
            this.selectList = ev
        },
        async printOrder(){
            if(this.selectList.length==0){
                this.$message.error('请先选择需要打印的物料')
                return
            }
           
            localStorage.setItem('printType','arrval')
            this.selectList.forEach(item=>item.arrivalCode=this.addForm.arrivalCode)
            localStorage.setItem('printData',JSON.stringify(this.selectList))
            let routeUrl = this.$router.resolve({path: "/PrintAll"});
            window.open(routeUrl.href, '_blank');
        },
        
    },
    filters:{
        parseTime(ev){
            if(!ev){
                return ''
            }
            return commonUtils.timestampToDate(ev,true)
        }
    }
}
</script>

<style scoped>
.table_searchbar .title11 {
    color: #606266;
    font-family: NotoSansHans-Regula;
    font-size: 14px;
}

/* .title {
    color: #606266;
    font-family: NotoSansHans-Regula;
    font-size: 14px;
    display: inline-block;
    text-align: right;
    width: 70px;
} */

.add_form .value {
    display: inline-block;
}

.el-row {
    margin-bottom: 20px;

    & :last-child {
        margin-bottom: 0;
    }
}


.import_upload {
    display: inline;
}

.page {
    display: flex;
    justify-content: flex-end;
}

@media screen and (max-width: 1450px) {
    .page {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 30px;
    }
}

.total_page {
    margin-top: 20px;
    margin-right: 26px;
    color: #606266;
    font-size: 14px;
}
</style>
<style>
.table_searchbar .el-button--mini,
.el-button--mini.is-round {
    padding: 7px 10px;
}

@media screen and (max-width: 1366px) {
    #pick-material-task .el-date-editor.el-input,
    #pick-material-task .el-date-editor.el-input__inner {
        width: 176px !important;
    }
}

@media screen and (min-width: 1400px) and (max-width: 1920px) {
    .y_records_width {
        width: 220px !important;
    }
}
</style>




// WEBPACK FOOTER //
// src/views/stock/NoticeOfArrival.vue